import { BadgeCheck } from "lucide-react";

const ClaimStatusBadge = ({ isVerified }) => {
  if (!isVerified) return null;

  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800">
      <BadgeCheck size={14} />
      Verified
    </span>
  );
};

export default ClaimStatusBadge;
